import React from "react";
import { TextBox, CheckBox, SelectField } from "../Shared/FormHelpers";

const PersonalDetailForm = ({
  profile,
  user,
  handleChange,
  countries,
  country,
  regions: regionProps,
}) => {
  const regions = regionProps.length ? regionProps : [country];
  return (
    <div className="profile_detail post">
      <div className="row">
        <div className="col-lg-2">
          <div className="searchable">
            <label htmlFor="searchable" className="css-label">
              <CheckBox
                name="searchable"
                id="searchable"
                onChange={handleChange}
                checked={profile.searchable}
              />
              Searchable
            </label>
          </div>
          <div className="searchable">
            <label htmlFor="primary" className="css-label">
              <CheckBox
                name="primary"
                id="primary"
                onChange={handleChange}
                checked={profile.primary}
              />
              Primary Profile
            </label>
          </div>
        </div>
      </div>
      <hr />
      <div className="row">
        <div className="col-lg-3" style={{ clear: "both" }}>
          <div className="form-group">
            <label>First Name</label>
            <TextBox
              type="text"
              className="form-control form-control-lg"
              name="fname"
              placeholder="First name"
              onChange={handleChange}
              value={user.fname}
              required
            />
          </div>
        </div>
        <div className="col-lg-3">
          <div className="form-group">
            <label>Last Name</label>
            <TextBox
              type="text"
              className="form-control form-control-lg"
              name="lname"
              placeholder="Last name"
              onChange={handleChange}
              value={user.lname}
              required
            />
          </div>
        </div>
        <div className="col-lg-3">
          <div className="form-group">
            <label>Email</label>
            <TextBox
              type="text"
              className="form-control form-control-lg"
              name="email"
              placeholder="Email"
              onChange={handleChange}
              value={user.email}
              disabled
              required
            />
          </div>
        </div>
        <div className="col-lg-3">
          <div className="form-group">
            <label>Primary Phone</label>
            <TextBox
              type="text"
              className="form-control form-control-lg"
              name="phone"
              placeholder="Primary Phone"
              onChange={handleChange}
              value={user.phone_primary}
              required
            />
          </div>
        </div>
        <div className="col-lg-3">
          <div className="form-group">
            <SelectField
              options={Array.from(new Set(countries)).sort((a, b) => b - a)}
              label="Country"
              name="country"
              onChange={handleChange}
              value={user.country}
              required
            />
          </div>
        </div>
        <div className="col-lg-3">
          <div className="form-group">
            <SelectField
              options={Array.from(new Set(regions)).sort((a, b) => b - a)}
              label="State"
              name="state"
              onChange={handleChange}
              value={user.state}
            />
          </div>
        </div>
        <div className="col-lg-3">
          <div className="form-group">
            <label>City</label>
            <TextBox
              className="form-control form-control-lg"
              type="text"
              name="city"
              placeholder="City"
              onChange={handleChange}
              value={user.city}
              required
            />
          </div>
        </div>
        <div className="col-lg-3">
          <div className="form-group">
            <label>Zip</label>
            <TextBox
              type="text"
              className="form-control form-control-lg"
              name="zip"
              placeholder="Zip"
              onChange={handleChange}
              value={user.zip}
              required
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PersonalDetailForm;
